import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { LangProvider } from "@/context/LangContext";
import { WishlistProvider } from "@/context/WishlistContext";
import { SettingsProvider } from "@/context/SettingsContext";

import StoreLayout from "@/components/store/StoreLayout";
import Home from "@/pages/store/Home";
import ProductDetails from "@/pages/store/ProductDetails";
import Cart from "@/pages/store/Cart";
import Checkout from "@/pages/store/Checkout";
import OrderConfirmation from "@/pages/store/OrderConfirmation";
import TrackOrder from "@/pages/store/TrackOrder";
import CustomerLogin from "@/pages/store/CustomerLogin";
import CustomerDashboard from "@/pages/store/CustomerDashboard";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminStock from "@/pages/admin/AdminStock";
import AdminProduction from "@/pages/admin/AdminProduction";
import AdminPurchases from "@/pages/admin/AdminPurchases";
import AdminSuppliers from "@/pages/admin/AdminSuppliers";
import AdminCustomers from "@/pages/admin/AdminCustomers";
import AdminSales from "@/pages/admin/AdminSales";
import AdminExpenses from "@/pages/admin/AdminExpenses";
import AdminDue from "@/pages/admin/AdminDue";
import AdminReports from "@/pages/admin/AdminReports";
import AdminSettings from "@/pages/admin/AdminSettings";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <LangProvider>
          <CartProvider>
            <WishlistProvider>
            <SettingsProvider>
            <BrowserRouter>
              <Toaster position="top-center" richColors />
              <Routes>
                <Route element={<StoreLayout />}>
                  <Route path="/" element={<Home />} />
                  <Route path="/product/:id" element={<ProductDetails />} />
                  <Route path="/cart" element={<Cart />} />
                  <Route path="/checkout" element={<Checkout />} />
                  <Route path="/order-confirm/:orderNo" element={<OrderConfirmation />} />
                  <Route path="/track" element={<TrackOrder />} />
                  <Route path="/login" element={<CustomerLogin />} />
                  <Route path="/account" element={<CustomerDashboard />} />
                </Route>

                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminLayout />}>
                  <Route index element={<Dashboard />} />
                  <Route path="orders" element={<AdminOrders />} />
                  <Route path="products" element={<AdminProducts />} />
                  <Route path="stock" element={<AdminStock />} />
                  <Route path="production" element={<AdminProduction />} />
                  <Route path="purchases" element={<AdminPurchases />} />
                  <Route path="suppliers" element={<AdminSuppliers />} />
                  <Route path="customers" element={<AdminCustomers />} />
                  <Route path="sales" element={<AdminSales />} />
                  <Route path="expenses" element={<AdminExpenses />} />
                  <Route path="due" element={<AdminDue />} />
                  <Route path="reports" element={<AdminReports />} />
                  <Route path="settings" element={<AdminSettings />} />
                </Route>
              </Routes>
            </BrowserRouter>
            </SettingsProvider>
            </WishlistProvider>
          </CartProvider>
        </LangProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
